var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 11.207 18.384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_414",
    "data-name": "Group 414",
    transform: "translate(-656.188 -363.637)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mobile_18994945",
    transform: "translate(656.588 364.037)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_406",
    "data-name": "Group 406",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1977",
    "data-name": "Path 1977",
    d: "M119.972,28.584h-7.536A1.435,1.435,0,0,1,111,27.149V12.435A1.435,1.435,0,0,1,112.435,11h7.536a1.435,1.435,0,0,1,1.435,1.435V27.149A1.435,1.435,0,0,1,119.972,28.584Z",
    transform: "translate(-111 -11)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x1: 2.678,
    transform: "translate(3.864 16.005)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1978",
    "data-name": "Path 1978",
    d: "M203.555,11v.5a1.077,1.077,0,0,1-1.077,1.077h-1.9A1.077,1.077,0,0,1,199.5,11.5V11",
    transform: "translate(-196.324 -11)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.8
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_413",
    "data-name": "Group 413",
    transform: "translate(658.357 369.461)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1986",
    "data-name": "Path 1986",
    d: "M11.764,66.089h0a6.593,6.593,0,0,0,2.974,1.716,1.486,1.486,0,0,0,1.43-.39l.435-.435a.446.446,0,0,0,0-.631l-1.095-1.095a.446.446,0,0,0-.631,0l-.69.69-2.28-2.28.69-.69a.446.446,0,0,0,0-.631L11.5,61.249a.446.446,0,0,0-.631,0l-.435.435a1.5,1.5,0,0,0-.385,1.45,6.593,6.593,0,0,0,1.711,2.955",
    transform: "translate(-10 -61.118)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.11c4b3d1f341ab51fedc26229b72cade.svg";
export { ForwardRef as ReactComponent };